// eslint-disable-next-line max-classes-per-file
export enum ShippingRateConditionType {
  WEIGHT = 'weight',
  PRICE = 'price',
}

export enum ShippingProfileType {
  General = 'general',
  Custom = 'custom',
}

export class ShippingZone {
  id?: number;

  name: string;

  countries: number[];

  isSelectAllCountries: boolean;

  rates: any[];

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.countries = model.countries ? model.countries.map((country: any) => country.id) : [];
    this.isSelectAllCountries = model.isSelectAllCountries || null;
    this.rates = model.rates || [];
  }
}

export interface IShipping {
  id?: number;
  name: string;
  type: ShippingProfileType;
  zones: ShippingZone[];
}

export class Shipping implements IShipping {
  id?: number;

  name: string;

  type: ShippingProfileType;

  zones: ShippingZone[];

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.zones = model.zones ? model.zones.map((zone: ShippingZone) => new ShippingZone(zone)) : [];
  }
}
